import { Component, Input, OnInit } from '@angular/core';
import { Ng1AuthService } from '../shared/ng1/ng1-auth.service';
import { Ng1LiveChatService } from '../shared/ng1/ng1-live-chat.service';
import { PaymentService } from '../shared/services/payment.service';

@Component({
  selector: 'cc-wide-alert',
  templateUrl: './wide-alert.component.html',
  styleUrls: ['./wide-alert.component.scss']
})
export class WideAlertComponent implements OnInit {
  @Input() directPayment: boolean;

  public isOwner: boolean;
  constructor(
    public authService: Ng1AuthService,
    public ng1LiveChatService: Ng1LiveChatService,
    public paymentService: PaymentService
  ) {}

  ngOnInit() {
    this.isOwner =
      this.authService.hasPermission('CHANGE_BILLING_PERMISSION') && this.authService.hasPermission('PLANS_PERMISSION');
  }

  contactSupport() {
    this.ng1LiveChatService.contactSupport();
  }

  pay() {
    this.paymentService.payNonDirectPayment();
  }
}
